export default () => global && global.window;



// WEBPACK FOOTER //
// ./src/Common/isWindow/index.js